import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getIsInDetachMode } from "src/duck/selectors";
import { useParentStation } from "src/modules/parent-station/ParentStation/Context";

export default function AnimationBox({ children, height, width, ...rest }) {
  const parentStation = useParentStation();
  const { showTilesView } = parentStation;
  const isInDetachMode = useSelector(getIsInDetachMode);
  return (
    <Box
      sx={{
        // "@media (min-height: 530px) and (min-width: 992px)": {
        //   height: "295px",
        //   width: "406px"
        // },

        // "@media (min-height: 590px) and (min-width: 1200px)": {
        //   height: "354px",
        //   width: "487px"
        // }

        height: "auto",
        width: "56vmin"
      }}
      {...(!isInDetachMode && {
        minW: width || (showTilesView ? "100%" : "290px"),
        minH: height || (showTilesView ? "auto" : "211px")
      })}
      {...(isInDetachMode && {
        width: "75.1vmin !important",
        height: "54.6vmin !important",
        sx: {
          "@media (max-height: 140px)": {
            width: "32px",
            height: "32px"
          }
        }
      })}
      {...rest}
    >
      {children}
    </Box>
  );
}
